module.exports = __webpack_public_path__ + "img/ssn.1cddac9d.jpg";